import type { WritableComputedRef } from 'vue'
import cookieRef from './cookieRef'

/**
 * A reactive reference to a cookie value.
 * @param cookieName The name of the cookie.
 */
export default <T>(cookieName: string) => {
  let current: T | undefined

  const log = useLog('cookieRef')
  const stringified = cookieRef(cookieName)

  return computed({
    get() {
      try {
        if (current) return current
        current = stringified.value ? JSON.parse(stringified.value) : undefined
        return current
      } catch (e) {
        log.warn(`Failed to parse cookie "${cookieName}": "${e}"`)
        return undefined
      }
    },
    set(value: T | undefined) {
      try {
        current = value
        stringified.value = value ? JSON.stringify(value) : undefined
      } catch (e) {
        log.warn(
          `Failed to stringify cookie value "${cookieName}=${value}": "${e}"`,
        )
        return undefined
      }
    },
  }) as WritableComputedRef<T | undefined>
}
